import axios from 'axios';
import environment from 'environment';

import { JsonResponse } from 'core/models/response';
import { MinorsListResponse, Minor } from '../models/minors';

export const onGetMinors = (page: number = 1, search?: string) => {
	return axios.get<JsonResponse<MinorsListResponse>>(`${environment.BASE_API_ENDPOINT}/admin/minors`, {
		params: {
			page,
			search,
		},
	});
};

export const onGetMinorById = (minorId: string) => {
	return axios.get<JsonResponse<Minor>>(`${environment.BASE_API_ENDPOINT}/admin/minors/${minorId}`);
};

export const onDeleteMinor = (minorId: string) => {
	return axios.delete<JsonResponse<Minor>>(`${environment.BASE_API_ENDPOINT}/admin/minors/${minorId}`);
};

export const onRejectMinor = (minorId: string,rejection_reason: string) => {
	return axios.put<JsonResponse<Minor>>(`${environment.BASE_API_ENDPOINT}/admin/minors/reject/${minorId}`, {
		rejection_reason
	});
};

export const onApproveMinor = (minorId: string) => {
	return axios.put<JsonResponse<Minor>>(`${environment.BASE_API_ENDPOINT}/admin/minors/approve/${minorId}`);
};

export const onUnlinkMinor = (minorId: string) => {
	return axios.put(`${environment.BASE_API_ENDPOINT}/admin/minors/unlink/${minorId}`);
};
